import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { setFuelType } from 'Store/AssetManagement/FuelType/FuelTypeAction';
import { GET_FUEL_TYPE } from 'Store/AssetManagement/FuelType/FuelTypeTypes';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getFuelType(request: any): any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/vehicle/fueltype/${request.subTypeId}`,
        payload : null
    }

    try {
        yield put(globalLoaderText("Fetching Values..."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response?.length > 0) {
            const defaultOption = {
                text: "Select Fuel Type",
                value: null
            };
            response.unshift(defaultOption);
        }
        yield put(setFuelType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setFuelType([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetFuelType() {
    yield takeEvery(GET_FUEL_TYPE, getFuelType)
}

export default function* combinedSaga() {
    yield all([
        watchGetFuelType()
    ])
}